const SAVED_LOCALE = 'saved_locale'
const SELECTED_CHATBOT_ID = 'selected_chatbot_id'

export { SAVED_LOCALE, SELECTED_CHATBOT_ID }
